import React from 'react';
import { Check, Minus } from 'lucide-react';

const LIFECYCLE_KEYS = ['issued', 'sent', 'viewed', 'paid'];

export function deriveLifecycle(statusGroup, t) {
  const doneCount =
    statusGroup === 'paid'     ? 4 :
    statusGroup === 'overdue'  ? 2 :
    statusGroup === 'disputed' ? 2 :
    2;
  const activeIdx = statusGroup === 'paid' ? -1 : doneCount;
  return LIFECYCLE_KEYS.map((key, i) => ({
    key,
    label: t(`invoices.lifecycle_${key}`),
    status:   i < doneCount ? 'done' : i === activeIdx ? 'active' : 'pending',
    overdue:  statusGroup === 'overdue',
    disputed: statusGroup === 'disputed',
  }));
}

function StepCircle({ status, overdue, disputed }) {
  if (status === 'done') {
    return (
      <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center">
        <Check size={14} strokeWidth={2.5} className="text-white" />
      </div>
    );
  }
  if (status === 'active') {
    const bg = overdue ? 'bg-rose-500' : disputed ? 'bg-violet-500' : 'bg-amber-400';
    return (
      <div className={`w-9 h-9 rounded-full ${bg} flex items-center justify-center`}>
        <Minus size={14} strokeWidth={2.5} className="text-white" />
      </div>
    );
  }
  return <div className="w-9 h-9 rounded-full border-2 border-slate-200 bg-white" />;
}

export function LifecycleStepper({ steps }) {
  const N = steps.length;
  return (
    <div>
      <div className="flex items-center">
        {steps.map((step, i) => (
          <React.Fragment key={step.key}>
            <div className="flex-shrink-0">
              <StepCircle status={step.status} overdue={step.overdue} disputed={step.disputed} />
            </div>
            {i < N - 1 && (
              <div className={`flex-1 h-0.5 ${step.status === 'done' ? 'bg-primary' : 'bg-slate-200'}`} />
            )}
          </React.Fragment>
        ))}
      </div>
      <div className="flex mt-2">
        {steps.map((step, i) => (
          <React.Fragment key={step.key}>
            <div className="flex-shrink-0 w-9 flex justify-center">
              <span className={`text-[11px] font-medium text-center whitespace-nowrap ${
                step.status === 'pending' ? 'text-slate-400' : 'text-slate-700'
              }`}>
                {step.label}
              </span>
            </div>
            {i < N - 1 && <div className="flex-1" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
